type PermissionMapping = {
    [key: string]: {
        controller: string;
        function: string;
    };
};

export const TaskHeaderMapping: PermissionMapping = {
    // Marketing Lead
    'analytics_dashboard': {controller: 'task_assignment',function: 'analytics_dashboard'},
    'task_list': {controller: 'task_assignment',function: 'task_list'},
    'todo_list': {controller: 'task_assignment',function: 'todo_list'},
    'task_configuration': {controller: 'task_assignment',function: 'task_configuration'},
    'set_priority_listing': {controller: 'task_assignment',function: 'set_priority_listing'},
    'work_space_management': {controller: 'task_assignment',function: 'work_space_management'},
};